import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Button, Wrapper, Menu, MenuItem } from 'react-aria-menubutton';
import { useIsDesktop } from '../hooks/useMediaQuery';
import ArrowInicio from '../components/svg/ArrowInicio';
import { useMap } from '../contexts/mapContext';
import { usePage } from '../contexts/pageContext';
import { themes } from '../styles/themes';

/**
 * Selector que nos permite elegir entre distintos tipos de mapa
 */

const SelectMapa = props => {
  const [isOpen, setIsOpen] = useState(false);
  const isDesktop = useIsDesktop();
  const { maps } = useMap();
  const { data } = usePage();
  const colorEleccion =
    props?.nomenclator?.nomAmbitos?.[data.elec]?.c ?? '#c2c2c2';
  if (!(maps?.length > 1)) return null;

  return (
    <SWrapper
      onSelection={elec => props.setElec(elec)}
      onMenuToggle={({ isOpen }) => setIsOpen(isOpen)}
      isDesktop={isDesktop}
      colorEleccion={colorEleccion}
      style={{
        borderBottomLeftRadius: isOpen ? 0 : '25px',
        borderBottomRightRadius: isOpen ? 0 : '25px',
      }}
    >
      <SButton>
        <span>{props.elec.label}</span>
        <div
          style={{
            rotate: isOpen ? '180deg' : '0deg',
            transitionDuration: '150ms',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ArrowInicio />
        </div>
      </SButton>
      <SMenu>
        {maps
          //.filter(m => m.id !== props.elec.id)
          .map((map, index) => {
            return (
              <SMenuItem value={map} key={index}>
                {map.label}
              </SMenuItem>
            );
          })}
      </SMenu>
    </SWrapper>
  );
};

export default SelectMapa;

const SWrapper = styled(({ isDesktop, colorEleccion, ...rest }) => (
  <Wrapper {...rest} />
))`
  width: ${({ isDesktop }) => (isDesktop ? '45%' : '50%')};
  min-width: fit-content;
  margin: '0';
  color: white;
  cursor: pointer;
  position: relative;
  cursor: pointer;
  background-color: ${({ colorEleccion }) => colorEleccion};
  border-radius: 25px;
`;

const SButton = styled(Button)`
  text-transform: uppercase;
  display: flex;
  column-gap: 12px;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  & span {
    text-align: center;
  }
  & div,
  span {
    font-size: 16px;
    font-weight: 700;
    /* margin-left: auto; */
  }
`;

const SMenu = styled(Menu)`
  text-align: center;
  position: absolute;
  width: inherit;
  background-color: ${themes.inicio.backgroundColor};
  box-shadow: 0px 2px 5px rgba(228, 228, 228, 0.88);
  z-index: 1;
  width: 100%;
  color: black;
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
`;

const SMenuItem = styled(MenuItem)`
  margin-right: 10px;
  width: 100%;
  text-transform: uppercase;
  background: none;
  padding: 0.5em 0;
  font-weight: bold;
  cursor: pointer;
  :hover {
    font-weight: 900;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.2);
  }
`;
